export const SET_A11Y_CONTENT = "SET_A11Y_CONTENT";

export const setA11yContent = (screenReaderMessage, title, metaDescription) => dispatch => {
  const payload = {
    screenReaderMessage
  };

  if (title) {
    payload.title = title;
  }

  if (metaDescription) {
    payload.metaDescription = metaDescription;
  }

  dispatch({
    type: SET_A11Y_CONTENT,
    payload
  });
};
